import RecaudacionService from '@/services/recaudacion.services'
export const namespaced = true

export const actions = {
  fetchRecaudacion(context, payload) {
    let params = 'params' in payload ? payload.params : null
    return RecaudacionService.getRecaudacion(payload.jwt, params)
  },
  addRecaudacion(context, payload) {
    return RecaudacionService.postRecaudacion(payload.jwt, payload.body)
  },
  editRecaudacion(context, payload) {
    return RecaudacionService.putRecaudacion(payload.jwt, payload.body, payload.id)
  },
  deleteRecaudacion(context, payload) {
    return RecaudacionService.deleteRecaudacion(payload.jwt, payload.body, payload.id)
  },
  fetchRecaudacionFile(context, payload) {
    let params = 'params' in payload ? payload.params : null
    //console.log(params)
    return RecaudacionService.getRecaudacionFile(payload.jwt, params)
  },
  addRecaudacionFile(context, payload) {
    return RecaudacionService.postRecaudacionFile(payload.jwt, payload.body, payload.id)
  },
  deleteRecaudacionFile(context, payload) {
    return RecaudacionService.deleteRecaudacionFile(payload.jwt, payload.body, payload.id)
  },
  imprimeRecaudacion(context, payload) {
    return RecaudacionService.putImpRecaudacion(payload.jwt, payload.body, payload.id)
  },
  finalizaRecaudacion(context, payload) {
    return RecaudacionService.putFinRecaudacion(payload.jwt, payload.body, payload.id)
  },
  RechazaRecaudacion(context, payload) {
    return RecaudacionService.putRechazaRecaudacion(payload.jwt, payload.body, payload.id)
  },
  activaRecaudacion(context, payload) {
    return RecaudacionService.putActivaRecaudacion(payload.jwt, payload.body, payload.id)
  },

}
